import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/duihao.png';
const _withScopeId = n => (_pushScopeId("data-v-4cb9c546"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "admin-dialog"
};
const _hoisted_2 = {
  class: "box_cb"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "box_title_remaker"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "remaker_item"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "_left_"
}, "文心一言格式："), /*#__PURE__*/_createElementVNode("span", {
  class: "_right_"
}, "ApiKey-SecretKey")]), /*#__PURE__*/_createElementVNode("div", {
  class: "remaker_item"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "_left_"
}, "讯飞星火格式："), /*#__PURE__*/_createElementVNode("span", {
  class: "_right_"
}, "AppId-ApiKey-ApiSecret")]), /*#__PURE__*/_createElementVNode("div", {
  class: "remaker_item"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "_left_"
}, "Azure格式："), /*#__PURE__*/_createElementVNode("span", {
  class: "_right_"
}, "Key|Endpoint|ApiVersion")]), /*#__PURE__*/_createElementVNode("div", {
  class: "remaker_item"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "_left_"
}, "其他类型："), /*#__PURE__*/_createElementVNode("span", {
  class: "_right_2"
}, "直接填写 KEY 值")])], -1));
const _hoisted_4 = {
  class: "plam_or"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "_l_one"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "icons",
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("span", {
  class: "text_s"
}, "官方")], -1));
const _hoisted_6 = {
  class: "text_t"
};
const _hoisted_7 = {
  class: "text_msx"
};
const _hoisted_8 = {
  class: "dialog-footer"
};
import { reactive, computed, ref, watch, nextTick } from "vue";
import { getmodel_list, addkey_post } from "@/service/modules/alllist";
import { ElMessage } from "element-plus";
export default /*#__PURE__*/_defineComponent({
  __name: 'config-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dialogType: {
      type: String,
      default: "addSubset"
    },
    itemData: {
      type: Object,
      default: () => {}
    }
  },
  emits: ["closeDialog", "restData"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const aimodel = ref([]);
    const emit = __emit;
    const subBtnLoading = ref(false);
    const form = reactive({
      id: "",
      name: "",
      value: "",
      status: 1,
      platform: "",
      model: ""
    });
    watch(() => props.dialogVisible, newValue => {
      if (newValue) {
        nextTick(async () => {
          if (props.dialogType === "edit") {
            form.id = props.itemData.id;
            form.name = props.itemData.name;
            form.value = props.itemData.value;
            form.status = props.itemData.status;
            form.platform = props.itemData.platform;
            form.model = props.itemData.model_list[0].id;
          } else {
            form.id = "";
            form.name = "";
            form.value = "";
            form.status = 1;
            form.platform = "";
            form.model = "";
          }
        });
      }
    });
    const platform_list = ref([{
      label: '百度',
      value: '百度'
    }]);
    const rules = {
      name: [{
        required: true,
        message: "请输入名称",
        trigger: "blur"
      }],
      value: [{
        required: true,
        message: "请输入KEY",
        trigger: "blur"
      }],
      platform: [{
        required: true,
        message: "请选择平台",
        trigger: "change"
      }],
      model: [{
        required: true,
        message: "请选择模型",
        trigger: "change"
      }],
      status: [{
        required: true,
        message: "请选择可用性",
        trigger: "change"
      }]
    };
    const title = computed(() => {
      if (props.dialogType === "add") {
        return "添加KEYS";
      } else if (props.dialogType === "edit") {
        return "编辑KEYS";
      }
    });
    const formRef = ref();
    function closeDialog() {
      if (subBtnLoading.value) return ElMessage.warning("正在保存，请稍后~~");
      restForm();
      formRef.value?.resetFields();
      emit("closeDialog");
    }
    function restForm() {
      form.id = "";
      form.username = "";
      form.password = "";
      form.status = 1;
      form.model = "";
    }
    function handleFooterBtn(actionType) {
      if (!actionType) {
        closeDialog();
        return;
      }
      formRef.value?.validate(valid => {
        if (valid) {
          submit();
        }
      });
    }
    async function submit() {
      subBtnLoading.value = true;
      let query = JSON.parse(JSON.stringify(form));
      try {
        let res = await addkey_post(query);
        ElMessage.success(props.dialogType === "add" ? "添加成功" : "修改成功");
        restForm();
        formRef.value?.resetFields();
        emit("restData");
      } catch {} finally {
        subBtnLoading.value = false;
      }
    }
    const get_config = async () => {
      let res = await getmodel_list();
      if (res.code == 0) {
        aimodel.value = res.data;
      }
    };
    get_config();
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        "model-value": __props.dialogVisible,
        title: title.value,
        width: "35%",
        top: "3vh",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true,
        "before-close": closeDialog
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_8, [_createVNode(_component_el_button, {
          onClick: _cache[5] || (_cache[5] = $event => handleFooterBtn(false))
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          loading: subBtnLoading.value,
          onClick: _cache[6] || (_cache[6] = $event => handleFooterBtn(true)),
          type: "primary"
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form,
          rules: rules,
          "status-icon": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "名称",
            prop: "name",
            class: "label_edits"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.name = $event),
              placeholder: "请输入"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "KEY值",
            prop: "value",
            class: "label_edits"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value = $event),
              placeholder: "请输入"
            }, null, 8, ["modelValue"]), _hoisted_3]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "平台",
            prop: "platform",
            class: "label_edits"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: form.platform,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.platform = $event)
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(platform_list.value, (item, index) => {
                return _openBlock(), _createBlock(_component_el_radio, {
                  label: item.value,
                  size: "large",
                  key: index
                }, {
                  default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("span", _hoisted_6, _toDisplayString(item.label), 1)])]),
                  _: 2
                }, 1032, ["label"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "模型集",
            prop: "model",
            class: "label_edits"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: form.model,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.model = $event)
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aimodel.value, (item, index) => {
                return _openBlock(), _createBlock(_component_el_radio, {
                  label: item.id,
                  size: "large",
                  key: index
                }, {
                  default: _withCtx(() => [_createElementVNode("div", _hoisted_7, _toDisplayString(item.cname), 1)]),
                  _: 2
                }, 1032, ["label"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "可用性",
            prop: "status",
            class: "label_edits"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              modelValue: form.status,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.status = $event),
              "active-value": 1,
              "inactive-value": 2,
              size: "large"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])])]),
        _: 1
      }, 8, ["model-value", "title"])]);
    };
  }
});